import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from '../ReportFormUi';
import '../../SchoolEventView.scss';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  activeSchoolId: string;
}

//report 009
export const EventConsentRequestsReportForm = ({ onCloseClick, onSubmit, activeSchoolId }: Props) => {
  const [schoolData, setSchoolData] = React.useState<any>(null);

  React.useEffect(() => {
    fetch('/dist/images/mis/misIntegrationSchoolsList.json')
      .then(response => response.json())
      .then(data => {
        const matchedSchoolData = data.find(item => item.schoolSITId === activeSchoolId);
        setSchoolData(matchedSchoolData);
      })
      .catch(error => console.error('Error loading JSON:', error));
  }, [activeSchoolId]);
  const requestInitial = {
    isPrintMedicalInfo: schoolData ? schoolData.studentsMedicalInfo === 1 : false,
    isPrintNextOfKin: true
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_CONSENT_REQUESTS)}
      initialValues={requestInitial}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Extract consent request information, response status, answers to additional questions, and selected student
            safeguarding details where available.
          </ReportDescription>

          <ReportSection
            number={1}
            title="Include in the report"
            hint="Choose which consent and student details should appear in the generated document."
          >
            <ReportToggleList>
              {schoolData && schoolData.studentsMedicalInfo === 1 && (
                <ReportToggle
                  name="isPrintMedicalInfo"
                  label="Show medical info"
                  hint="Show any medical information relating to students."
                  value={values.isPrintMedicalInfo}
                  onChange={value => setFieldValue('isPrintMedicalInfo', value)}
                />
              )}
              <ReportToggle
                name="isPrintNextOfKin"
                label="Show next of kin details"
                hint="Show emergency contact details relating to specific students."
                value={values.isPrintNextOfKin}
                onChange={value => setFieldValue('isPrintNextOfKin', value)}
              />
            </ReportToggleList>
          </ReportSection>

          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
};
